import React, { useEffect, useState } from 'react'

import {
  DisplayActivities,
  DisplayCompanyRelations,
  DisplayExternalActivities,
  DisplayProcesses,
  DisplayProducts,
  DisplaySocialMedia,
  DisplayFinancialEntityPosition,
  DisplayInvestmentRobots,
  DisplayXPKinshipRelations,
  DisplayPEPRelations,
  DisplayAttorneyActivities,
  DisplayRestrictiveLists,
  DisplayNegativeMedias,
  DisplayThirdPartyInvestments,
  DisplayTermsAgreement,
  DisplayAddress,
} from 'components/DueDiligence/Questions'

import { Expansible } from 'components/Expansible'
import { DATA_FIELDS_NAMES } from 'utils/constants/dataFields'
import Colors from 'utils/Colors'
import { cloneDeep } from 'lodash'

import { formQuestionHasPositiveAnswer } from 'utils/formAnswers'
import styles from './styles'

function DisplayAnswers(props) {
  const { formResponses, open = false, condensed = false } = props

  const classes = styles()

  const [listOne, setListOne] = useState([])
  const [listTwo, setListTwo] = useState([])

  const hasPositiveAnswer = (currentQuestion) => {
    return (
      currentQuestion.has_answer && formQuestionHasPositiveAnswer(currentQuestion)
    )
  }

  const addKeyToResponses = (currentResponses) => {
    const newResponses = cloneDeep(currentResponses)
    Object.keys(currentResponses)?.forEach((key) => {
      const newResponse = cloneDeep(currentResponses[key])
      newResponse.has_positive_answer = hasPositiveAnswer(currentResponses[key])
      newResponses[key] = newResponse
    })
    return newResponses
  }

  const splitResponsesByAnswer = (responses) => {
    const keys = Object.keys(responses)
    const positiveKeys = keys.filter(
      (key) => responses[key].has_positive_answer,
    )
    const negativeKeys = keys.filter(
      (key) => !responses[key].has_positive_answer,
    )

    const positive = {}
    const negative = {}

    positiveKeys.forEach((key) => {
      positive[key] = responses[key]
    })

    negativeKeys.forEach((key) => {
      negative[key] = responses[key]
    })

    return [positive, negative]
  }

  const buildQuestionItem = (question) => {
    return (
      <div className={classes.answerDisplay}>
        {question === 'social_networks' ? (
          <DisplaySocialMedia questionData={formResponses[question]} />
        ) : null}
        {question === 'address' ? (
          <DisplayAddress questionData={formResponses[question]} />
        ) : null}
        {question === 'relation_with_another_companies' ? (
          <DisplayCompanyRelations questionData={formResponses[question]} />
        ) : null}
        {['financial_activities', 'environment_related_activities'].includes(
          question,
        ) ? (
          <DisplayActivities questionData={formResponses[question]} />
        ) : null}
        {question === 'external_activities' ? (
          <DisplayExternalActivities questionData={formResponses[question]} />
        ) : null}
        {[
          'national_product_offering_activities',
          'international_product_offering_activities',
        ].includes(question) ? (
          <DisplayProducts questionData={formResponses[question]} />
        ) : null}
        {question === 'representation_activities' ? (
          <DisplayFinancialEntityPosition
            questionData={formResponses[question]}
          />
        ) : null}
        {question === 'automation_activities' ? (
          <DisplayInvestmentRobots questionData={formResponses[question]} />
        ) : null}
        {question === 'kinship_xp' ? (
          <DisplayXPKinshipRelations questionData={formResponses[question]} />
        ) : null}
        {question === 'pep_relationship' ? (
          <DisplayPEPRelations questionData={formResponses[question]} />
        ) : null}
        {question === 'attorney_activities' ? (
          <DisplayAttorneyActivities questionData={formResponses[question]} />
        ) : null}
        {question === 'financial_pendings_data' ? (
          <DisplayAttorneyActivities questionData={formResponses[question]} />
        ) : null}
        {question === 'third_party_investments' ? (
          <DisplayThirdPartyInvestments
            questionData={formResponses[question]}
          />
        ) : null}
        {[
          'court_lawsuit_cvm_bacen_sfn',
          'environmental_court_lawsuit',
          'criminal_court_lawsuit',
        ].includes(question) ? (
          <DisplayProcesses questionData={formResponses[question]} />
        ) : null}
        {question === 'negative_media' ? (
          <DisplayNegativeMedias questionData={formResponses[question]} />
        ) : null}
        {question === 'restrictive_list' ? (
          <DisplayRestrictiveLists questionData={formResponses[question]} />
        ) : null}
        {question === 'terms_agreement' ? (
          <DisplayTermsAgreement questionData={formResponses[question]} />
        ) : null}
      </div>
    )
  }

  const buildAnswersList = (responses) => {
    return Object.keys(responses).map((question) => {
      const currentQuestion = responses[question]
      const mustOpen = currentQuestion?.has_positive_answer
      return condensed ? (
        <Expansible
          title={DATA_FIELDS_NAMES[question]}
          key={question}
          color={Colors.lightGray}
          open={mustOpen}
        >
          {buildQuestionItem(question)}
        </Expansible>
      ) : (
        <Expansible
          title={DATA_FIELDS_NAMES[question]}
          key={question}
          color={Colors.lightGray}
          open={open}
        >
          {buildQuestionItem(question)}
        </Expansible>
      )
    })
  }

  const buildCondensedLists = (responses) => {
    const list = addKeyToResponses(responses)
    const [positive, negative] = splitResponsesByAnswer(list)
    setListOne(buildAnswersList(positive))
    setListTwo(buildAnswersList(negative))
  }

  const buildNormalLists = (responses) => {
    const list = buildAnswersList(responses)
    const arrayLength = list.length
    const halfOfArray = Math.floor((arrayLength % 2) + arrayLength / 2)
    setListOne(list.slice(0, halfOfArray))
    setListTwo(list.slice(halfOfArray, arrayLength))
  }

  useEffect(() => {
    if (condensed) {
      buildCondensedLists(formResponses)
    } else {
      buildNormalLists(formResponses)
    }
  }, [formResponses])

  return condensed ? (
    <div className={classes.answersWrapper}>
      {listOne.length > 0 && (
        <React.Fragment>
          <span className={classes.title}>Respostas com ocorrências</span>
          <div className={classes.answerColumnUnique}>{listOne}</div>
        </React.Fragment>
      )}
      {listTwo.length > 0 && (
        <React.Fragment>
          <span className={classes.title}>Respostas sem ocorrências</span>
          <div className={classes.answerColumnUnique}>{listTwo}</div>
        </React.Fragment>
      )}
    </div>
  ) : (
    <div className={classes.answersWrapper}>
      <div className={classes.answerColumn}>{listOne}</div>
      <div className={classes.answerColumn}>{listTwo}</div>
    </div>
  )
}

export default DisplayAnswers
